/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, BrickContext } from 'olympe';
import { getRootTimeoutMap } from '../utils/_helpers';

export default class SetInRootTimeoutMap extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} key
     * @param {*} data
     * @param {function(): void} forwardEvent
     */
    update($, [key, data], [forwardEvent]) {
        const rootCache = getRootTimeoutMap($);
        rootCache.set(key, data);
        forwardEvent();
    }
}

registerBrick('018b3870e6e88640853b', SetInRootTimeoutMap);
